<script>
  import ListHeader from '../../../../app/components/list/Header.vue'
  import FormSaveButton from '../../../../app/components/form/SaveButton.vue'
  import FormCancelButton from '../../../../app/components/form/CancelButton.vue'
  import * as restfulService from '../../../services/restfulService'
  import * as notifyService from '../../../services/notifyService'
  import {clone} from 'lodash'
  import {required} from 'vuelidate/lib/validators'
  import bus from '@utils/bus'

  export default {
    components: {ListHeader, FormSaveButton, FormCancelButton},
    data () {
      return {
        isEdit: false,
        isSubmitted: false,
        isLoadingData: true,
        form: {
          name: '',
          description: ''
        },
        dependencies: {}
      }
    },
    validations: {
      form: {
        name: {required},
        description: {required}
      }
    },
    mounted () {
      const id = this.$route.params.id || null
      if (id) {
        this.isEdit = true
        restfulService.get('modality', null, id)
          .then(response => {
            this.form = response
            this.isLoadingData = false
            bus.$emit('hide-loader')
          })
          .catch(e => {
            console.log(e)
            this.isLoadingData = false
            bus.$emit('hide-loader')
          })
      } else {
        this.isLoadingData = false
        bus.$emit('hide-loader')
      }
    },
    methods: {
      onSend () {
        this.isSubmitted = true
        const data = clone(this.form)
        restfulService.save('modality', null, null, data)
          .then(() => {
            notifyService.success({hideLoader: true})
            this.isSubmitted = false
            this.$router.push({name: 'modality.index'})
          })
          .catch(e => {
            this.isSubmitted = false
            console.log(e)
          })
      }
    }
  }
</script>

<template>
    <div v-if="!isLoadingData">

        <ListHeader title="Modalidades"/>

        <el-card class="el-card__save_form box-card">
            <div slot="header">
                <span>Dados das Modalidades</span>
            </div>
            <el-form ref="form"
                     :model="form"
                     label-width="20%"
                     v-on:submit.prevent="onSend">
                <el-form-item label="Nome"
                              class="is-required"
                              v-bind:class="{ 'el-form-item--error': $v.form.name.$error }">
                    <el-input v-model="form.name"
                              @input="$v.form.name.$touch()"></el-input>
                    <div class="el-form-item__error" v-if="$v.form.name.$error">Esse campo é obrigatório</div>
                </el-form-item>
                <el-form-item label="Descrição"
                              class="is-required"
                              v-bind:class="{ 'el-form-item--error': $v.form.description.$error }">
                    <el-input v-model="form.description"
                              @input="$v.form.description.$touch()"></el-input>
                    <div class="el-form-item__error" v-if="$v.form.description.$error">Esse campo é obrigatório</div>
                </el-form-item>
                <el-form-item>
                    <form-save-button :event-click="onSend"
                                      :is-disabled="isSubmitted || $v.$invalid"
                                      :is-submitted="isSubmitted">
                    </form-save-button>
                    <form-cancel-button route-name="modality.index"/>
                </el-form-item>
            </el-form>
        </el-card>
    </div>
</template>



// WEBPACK FOOTER //
// Form.vue?e40c57dc